import script from "./dro-layout-simple.vue?vue&type=script&setup=true&lang=js"
export * from "./dro-layout-simple.vue?vue&type=script&setup=true&lang=js"

import "./dro-layout-simple.vue?vue&type=style&index=0&id=0980d2e8&lang=scss"

const __exports__ = script;

export default __exports__